export default "__VITE_ASSET__02add96d__"